import { call, put, takeLatest } from "@redux-saga/core/effects";
import {
  errorTimeOffRequestsAction,
  responseTimeOffRequestsAction,
  responseApproveTimeOffRequestAction,
  errorApproveTimeOffRequestAction,
  responseGetTimeOffByIdAction,
  errorGetTimeOffByIdAction,
  responseUpdateTimeOffRequestAction,
  errorUpdateTimeOffRequestAction,
  responseCreateTimeOffRequestAction,
  errorCreateTimeOffRequestAction,
  TIMEOFF_MANAGER_ACTION,
} from "./TimeOffManagerActionCreator";
import TimeOffService from "../../Services/RestApiManager/TimeOffManager/TimeOffService";

export function* getTimeOffRequestsRequest(action) {
  try {
    const response = yield call(
      TimeOffService.shared.getTimeOffRequestsRequest,
      action.data
    );
    yield put(responseTimeOffRequestsAction(response));
  } catch (error) {
    yield put(errorTimeOffRequestsAction(error));
  }
}


export function* approveTimeOffRequestRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.approveTimeOffRequestRequest, action.data);
    yield put(responseApproveTimeOffRequestAction(response));
  } catch (error) {
    yield put(errorApproveTimeOffRequestAction(error));
  }
} 
export function* getTimeOffByIdRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.getTimeOffByIdRequest, action.data);
    yield put(responseGetTimeOffByIdAction(response));
  } catch (error) {
    yield put(errorGetTimeOffByIdAction(error));
  }
}

export function* updateTimeOffRequestRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.updateTimeOffRequestRequest, action.data.id, action.data.payload);
    yield put(responseUpdateTimeOffRequestAction(response));
  } catch (error) {
    yield put(errorUpdateTimeOffRequestAction(error));
  }
}

// Create Time Off Request Saga
export function* createTimeOffRequestRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.createTimeOffRequestRequest, action.data);
    yield put(responseCreateTimeOffRequestAction(response));
  } catch (error) {
    yield put(errorCreateTimeOffRequestAction(error));
  }
}
export function* timeOffManagerWatcherSaga() {
  yield takeLatest(
    TIMEOFF_MANAGER_ACTION.REQUEST_TIMEOFF_REQUESTS,
    getTimeOffRequestsRequest
  );

  yield takeLatest(
    TIMEOFF_MANAGER_ACTION.REQUEST_APPROVE_TIMEOFF_REQUEST,
    approveTimeOffRequestRequest
  );

  yield takeLatest(
    TIMEOFF_MANAGER_ACTION.REQUEST_GET_TIMEOFF_BY_ID,
    getTimeOffByIdRequest
  );

  yield takeLatest(
    TIMEOFF_MANAGER_ACTION.REQUEST_UPDATE_TIMEOFF_REQUEST,
    updateTimeOffRequestRequest
  );

  yield takeLatest(
    TIMEOFF_MANAGER_ACTION.REQUEST_CREATE_TIMEOFF_REQUEST,
    createTimeOffRequestRequest
  );
}
